import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell } from "@/components/DashboardShell";
import { CUSTOMER_NAV } from "@/lib/nav";
import { VERIFICATION_STATUSES, type VerificationStatus } from "@/lib/mock-data";
import { VerificationBadge } from "@/components/StatusBadge";
import { VerificationFlow } from "@/components/VerificationFlow";

export const Route = createFileRoute("/_authenticated/customer/verification")({
  head: () => ({
    meta: [
      { title: "Verification · Landoo" },
      {
        name: "description",
        content: "Verify your identity to enjoy trusted messaging on Landoo.",
      },
    ],
  }),
  component: () => (
    <DashboardShell title="Verification" role="Customer" items={CUSTOMER_NAV}>
      <VerificationFlow />
      <div className="mt-4 rounded-2xl border border-border bg-card p-5 shadow-soft">
        <div className="text-xs uppercase tracking-wider text-muted-foreground">All statuses</div>
        <div className="mt-2 flex flex-wrap gap-2">
          {VERIFICATION_STATUSES.map((s: VerificationStatus) => (
            <VerificationBadge key={s} status={s} />
          ))}
        </div>
      </div>
    </DashboardShell>
  ),
});
